import React, { useState, useEffect } from "react";
import { Button } from "../../../../Ui_Components/Button";

interface DuplicateMealOptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDuplicate: (newName: string) => void;
  originalName: string;
  isLoading?: boolean;
}

const DuplicateMealOptionModal: React.FC<DuplicateMealOptionModalProps> = ({
  isOpen,
  onClose,
  onDuplicate,
  originalName,
  isLoading = false,
}) => {
  const [optionName, setOptionName] = useState(`COPY - ${originalName}`);

  useEffect(() => {
    if (isOpen) {
      setOptionName(`COPY - ${originalName}`);
    }
  }, [isOpen, originalName]);

  const handleDuplicate = () => {
    if (!optionName.trim()) return;
    onDuplicate(optionName);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-md w-full max-w-md p-6">
        <h2 className="text-lg font-medium text-[#1F1F1F] mb-4">
          Duplicate meal option
        </h2>

        <div className="mb-6">
          <label className="block text-sm font-medium text-[#1F1F1F] mb-2">
            Option name
          </label>
          <input
            type="text"
            value={optionName}
            onChange={(e) => setOptionName(e.target.value)}
            className="w-full px-3 py-2 border border-[#E5E5EA] rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0DB5B5] focus:border-transparent"
            placeholder="Enter option name"
            disabled={isLoading}
          />
        </div>

        <div className="flex justify-end gap-3">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleDuplicate}
            disabled={!optionName.trim() || isLoading}
          >
            {isLoading && (
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            )}
            {isLoading ? 'Duplicating...' : 'Save & duplicate'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateMealOptionModal;